import { ApiClientProps } from "hooks/useApi";

export interface CRMConfigResponse {
    hasErrors: boolean;
    message: string;
    resource: CrmFlag[];
}

export interface CrmFlag {
    name: string;
    enabled: boolean;
}
interface GetCRMProps {
    id?: number;
    locationId?: string;
    partnerId: string | undefined;
    posType: string | null | undefined;
    apiClient: ApiClientProps;
}
const getCRMConfig = async ({
  locationId,
  partnerId,
  posType,
  apiClient,

}: GetCRMProps): Promise<CRMConfigResponse> => {
    if (!locationId || !posType || !partnerId) {
        throw new Error("Missing required parameters to fetch CRM config.");
    }
    const response = await apiClient.get({
      path: `/middleware-admin/partners/${partnerId}/locations/${locationId}/flags`,
      noRetry: true,
    });
    return response;
};
export default getCRMConfig;










